import React, { useEffect, useState } from "react";
import wifiIcon from "../../../../src/assets/images/Header/notificationInfo.svg";
import { withTranslation } from "react-i18next";
import { IoMdClose } from "react-icons/io";
import { makeAjax, respStatus, showMessage, url } from "../../../helpers/global_helper";

const NotificationInfo = (props) => {
  const { notification, onClose } = props
  const [notificationData, setNotificationData] = useState('');

  const fetchNotificationBody = () => {
    let reqData = {
      notification_id: notification.id,
    };
    makeAjax(url.PLAYER_API.getNotification, reqData, url.PLAYER_MS_EXT).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage("server error No data find", "error", "error");
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      const newData = response.data; // Assuming your API returns an array of items
      setNotificationData(newData);
    });
  };
useEffect(() => {
  fetchNotificationBody();
  }, [notification.id]);
    return (
    <>
      <div className="Inner-popup-overlay" onClick={onClose}></div>
      <div className="Inner-popup">
        <div className="innerpopup-heading">
          <h1>{props.t('information')}</h1>
          <button className="notification_popup-close" onClick={onClose}>
            <IoMdClose className="btnclose"/>
          </button>
        </div>

        <h2 style={{ textAlign: "center" }}>{notification.subject}</h2>
        <p dangerouslySetInnerHTML={{ __html: notificationData }}></p>
      </div>
    </>
  );
};

export default withTranslation()(NotificationInfo);
